import api from './api';

// 列表序号
export function getListIndex(val, listParam) {
  return val + 1 + (listParam.page - 1) * listParam.limit
}

// 价格
export function price(val, type) {
  if (!val || val.length === 0) {
    return "0.00"
  }
  if (type === 3) {
    return (val / 10000).toFixed(3);
  }
  return (val / 10000).toFixed(2);
}

// 获取图片地址
export function getPic(url) {
  if (!url || url == undefined) {
    return ""
  }
  if (url.startsWith("http")) {
    return url
  }
  return api.public.oss.path + url;
}

/**
 * 直接截取 后两位
 * @param price
 * @returns {number}
 */
export function getPrice(price) {
  if (!price || price == '0') {
    return 0.00
  }

  return (Math.floor(price * 100) / 100).toFixed(2)
}

/**
 *想上取整
 * @param price
 */
export function getmaxPrice(price) {
  if (!price || price == '0') {
    return 0.00
  }
  return (Math.ceil(price * 100) / 100).toFixed(2)
}

/**
 * 获取年月日时分
 * @param time
 * @returns {string}
 */
export function formatTime(time) {
  if (time == '0') {
    return '--'
  }
  let date = new Date(time * 1000);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second;
}

/**
 * 获取年月日时分
 * @param time
 * @returns {string}
 */
export function formatSimpleTime(time, type) {
  if (time == '0') {
    return '--'
  }
  let date = new Date(time * 1000);
  let y = date.getFullYear();
  let m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  if (type === 1) {
    return y + '-' + m + '-' + d;
  }
  return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
}

/**
 * 获取年月日
 * @param time
 * @returns {*}
 */
export function parseDate(time) {
  if (arguments.length === 0 || time == null || time == '0') {
    return "--";
  }
  let date = new Date(time * 1000);
  let y = date.getFullYear();
  let m = (date.getMonth() + 1) < 10 ? '0' + (date.getMonth() + 1) : (date.getMonth() + 1);
  let d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
  return y + '年' + m + '月' + d + "日";
}

/**
 * 获取年月日
 * @param time
 * @returns {*}
 */
export function parseMinute(time) {
  if (arguments.length === 0 || time == null || time == '0') {
    return '--';
  }
  let date = new Date(time * 1000);
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let minute = date.getMinutes();
  let second = date.getSeconds();
  minute = minute < 10 ? ('0' + minute) : minute;
  second = second < 10 ? ('0' + second) : second;
  return h + ':' + minute + ':' + second;
}



// WEBPACK FOOTER //
// ./src/utility/filter.js